import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {Card,CardBody,Row,Button} from "reactstrap";
import { useParams } from 'react-router-dom';
import '../../../assets/css/custom.css';
import { Alert } from "reactstrap";
import { API_URL, getApiConfig, getUserRoleId } from '../Config/apiConfig.js';


export default function ShowBoitierAssign({ user_id, customer_Name }) { 

    const params = useParams();

    const [userRole, setUserRole] = useState(null);
    const user_params_id = localStorage.getItem("user_params_id");
    useEffect(() => {
        setUserId(user_id);
    }, [user_id]);

    useEffect(() => {
        setCustomerName(customer_Name);
    }, [customer_Name]);
    
    const [customerName, setCustomerName] = useState('');
    const [userId, setUserId] = useState('');
    const [alert, setAlert] = useState(false);
    const [alertContent, setAlertContent] = useState('');

    const [assignVisible, setAssignVisible] = useState(false);
    const [assignSubmitted, setAssignSubmitted] = useState(false);

    const handleToggleAssign = () => {
        if (!assignVisible) {
            // Charger la liste seulement à l'ouverture du formulaire
            axios
              .get(API_URL + 'showCustomerListForAssign', getApiConfig())
              .then((res) => {
                setCustomerList(res.data);
              })
              .catch((err) => {
                setAlertContent(<Alert color="danger">Impossible de charger la liste des clients.</Alert>);
                setAlert(true);
                setTimeout(() => setAlert(false), 4000);
              });
        }
        setAssignVisible(!assignVisible);
      }

    const handleSubmitForAssignedUser = async e => {
        e.preventDefault();
        axios.post(API_URL + `updateCustomerName/${params.id}`, { user_id : userId }, getApiConfig())
        .then(function (response) {
            if(response.data === 'success')
            {
              setAlertContent(<Alert color="success">Les données ont bien été enregistré !</Alert>);
              setAlert(true);
              const timeId = setTimeout(() => {
                setAlert(false)
              }, 3000);
            } else {
              setAlertContent(<Alert color="danger">Une erreur est survenue, veuillez réessayer</Alert>);
              setAlert(true);
              const timeId = setTimeout(() => {
                setAlert(false)
              }, 3000);
            }
         }).catch((error) => {
            setAlertContent(<Alert color="danger">Une erreur est survenue lors de la réassignation.</Alert>);
            setAlert(true);
            setTimeout(() => setAlert(false), 4000);
         });

         setAssignSubmitted(false);
         setAssignVisible(false);
    }

    useEffect(() => {
        const fetchUserRole = async () => {
            const role = await getUserRoleId();
            setUserRole(role);
        };
    
        fetchUserRole();
    }, []);
    
  
    const [customerList, setCustomerList] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [isFocused, setIsFocused] = useState(false);

    // Modification du filtrage pour rechercher principalement par le nom de l'entreprise
    useEffect(() => {
        const results = customerList.filter(
          (customer) =>
            // Recherche par le nom de l'entreprise (priorité)
            (customer.company && 
             customer.company.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        setSearchResults(results);
      }, [searchTerm, customerList]);
    
      const handleSearch = (event) => {
        setSearchTerm(event.target.value);
      };

      // Modification pour afficher le nom de l'entreprise
      const handleSelectCustomer = (customer) => {
        setSelectedCustomer(customer);
        setUserId(customer.id);
        setSearchResults([]);
        
        // Utiliser le nom de l'entreprise
        const displayName = customer.company || `${customer.name} ${customer.firstname}`;
        setSearchTerm(displayName);
        setCustomerName(displayName);
      };
      
      // verifie que le role est un admin (1), distributeur (2) ou revendeur (3) : accès total
const checkAcessToAssign = () => {
  // Rôles 1 (Admin), 2 (Distributeur), 3 (Revendeur) : accès total
  if (userRole == 1 || userRole == 2 || userRole == 3) {
    return true;
  }
  return false;
};





  return (
    <>

    <div style={{ position: 'fixed', top: '10%', right: '10%', left: '20%', zIndex: '999' }}>
        {alert ? <div>{alertContent}</div> : <></> }
    </div>

    {!assignVisible || assignSubmitted ? (
        <div>
            <Card  className="cardContainer">
                <CardBody >
                    <div className="containerTextCard">
                        <h4  className="titleCard ">
                        CLIENT ASSIGNE
                        </h4>
                        <div style={{ borderTop: "0.5px solid #fff" , marginBottom:'20px'}}></div>
                        <Card className="rowContainer">
                            <Row>
                                <div className="titleRow" >
                                Client
                                </div>
                                <div className="textRow" >{customerName}</div>
                            </Row>
                        </Card>
                    </div>
                    <div className="text-center">
                        { checkAcessToAssign() && (
                            <Button color="primary" onClick={handleToggleAssign}>Editer</Button>
                        )}
                    </div>
                </CardBody>
            </Card>
        </div>
    ) : (
        <div>  
            <form onSubmit={handleSubmitForAssignedUser}>
                <Card  className="cardContainer">
                    <CardBody >
                        <div className="containerTextCard">
                            <h4  className="titleCard">
                            CLIENT ASSIGNE
                            </h4>
                            <div style={{ borderTop: "0.5px solid #fff" , marginBottom:'20px'}}></div>
                            <Card className="rowContainer">
                                <Row>
                                    <div className="titleRow">Client</div>
                                    <div className="textRow">
                                        <input className="" id="custom-input-row-noheight" autoComplete="off" type="search" value={searchTerm} onChange={handleSearch} onFocus={() => setIsFocused(true)} onBlur={() => setTimeout(() => setIsFocused(false), 150)} placeholder="Rechercher une entreprise..." />
                                        {isFocused && searchResults.length > 0 && (
                                            <div className="custom-search-result" onClick={() => setSearchResults([])}>
                                                <ul>
                                                    {searchResults.map((customer) => (
                                                        <li
                                                        key={customer.id}
                                                        className={selectedCustomer && selectedCustomer.id === customer.id ? "selected" : ""}
                                                        onClick={() => handleSelectCustomer(customer)}
                                                        >
                                                        {/* Afficher le nom de l'entreprise */}
                                                        {customer.company}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </Row>
                            </Card>
                        </div>
                        <div className="text-center">
                            <Button type="button" color="secondary" onClick={handleToggleAssign} style={{marginRight:'10px'}}>Annuler</Button>
                            <Button type="submit" color="primary">Enregistrer</Button>
                        </div>
                    </CardBody>
                </Card>
            </form>
        </div>
    )}
    </>
  );
};
